import { render, staticRenderFns } from "./exhibition-release-new.vue?vue&type=template&id=2fa27462&scoped=true&"
import script from "./exhibition-release-new.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-release-new.vue?vue&type=style&index=0&id=2fa27462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa27462",
  null
  
)

export default component.exports